import i18next from 'i18next';
import AlertList from '../../../../../components/Alerts/List/AlertList';
import AlertLogo from '../../../../../components/Shared/Icons/AlertLogo';

const ALERT_ROUTE_LIST = {
  path: ':currentAccountUuid/alerts',
  exact: true,
  additional: {
    component: AlertList,
    protected: true,
    title: i18next.t('titles:alerts'),
    icon: AlertLogo,
  },
};

export const ALERT_ROUTES = {
  // ------- For child accounts ------
  // ...

  // ------- For current accounts ------
  list: ALERT_ROUTE_LIST,
};
